"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.getAlphaUnlocks = getAlphaUnlocks;
const fetchReceipts_js_1 = require("./graphql/fetchReceipts.js");
const parseLockedTableId_js_1 = require("./graphql/parseLockedTableId.js");
const fetchTableData_js_1 = require("./sui-sdk/functions/fetchTableData.js");
// params coming soon, this defaults to all users, all times;
async function getAlphaUnlocks(params) {
    if (params.address || params.timeRange) {
        throw new Error("Params support coming soon, pass empty params");
    }
    const receipts = await (0, fetchReceipts_js_1.fetchReceiptsGql)();
    const ownerTablePair = (0, parseLockedTableId_js_1.parseLockedTableIdFromReceipts)(receipts);
    const owner_table = ownerTablePair.map((o) => {
        return [o.owner, o.tableId];
    });
    const unlocksData = await (0, fetchTableData_js_1.getUnlocksData)(owner_table);
    return { alphaUnlocks: unlocksData };
}
//# sourceMappingURL=getAlphaUnlocks.js.map